export enum BonusRewardsQueryKeys {
  ByUser = '/bonus-rewards/by-user',
  Aggregator = '/bonus-rewards/aggregator',
}
